const baseURL='https://api.aiworldcommunity.com/admin/api';
module.exports={baseURL};